"use server"

import type { WooCommerceProduct } from "@/services/woo-commerce-service"
import { getProducts } from "@/services/woo-commerce-service"

export async function searchProducts(
  query: string
): Promise<WooCommerceProduct[]> {
  const normalizedQuery = query.trim()

  if (normalizedQuery.length < 2) {
    return []
  }

  try {
    const products = await getProducts({
      search: normalizedQuery,
      per_page: 5,
      status: "publish",
    })
    return products
  } catch (error) {
    if (error instanceof Error) {
      throw error
    }

    throw new Error("Failed to search products")
  }
}
